export default function AppDownload() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            随时随地，畅享观影
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            手机、平板、电脑全端覆盖，走到哪看到哪
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-500/15 flex items-center justify-center mb-5">
                <i className="ri-smartphone-line text-2xl text-primary-500"></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                90影院全平台适配
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
                90影院采用响应式设计，完美适配手机、平板和电脑等各类设备。无需下载安装任何App，打开浏览器即可享受与桌面端一致的高清流畅观影体验。通勤路上、午休间隙、周末宅家——随时随地，精彩不停。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <div className="w-full sm:w-auto px-8 py-3 bg-background-200 rounded-lg border border-background-300/60 text-center cursor-pointer hover:bg-background-300/50 transition-colors">
                  <i className="ri-android-line text-lg text-foreground-600 mr-2"></i>
                  <span className="text-sm text-foreground-600 font-medium whitespace-nowrap">Android 网页版</span>
                </div>
                <div className="w-full sm:w-auto px-8 py-3 bg-background-200 rounded-lg border border-background-300/60 text-center cursor-pointer hover:bg-background-300/50 transition-colors">
                  <i className="ri-apple-line text-lg text-foreground-600 mr-2"></i>
                  <span className="text-sm text-foreground-600 font-medium whitespace-nowrap">iOS 网页版</span>
                </div>
              </div>
              <p className="text-xs text-foreground-400 mt-4">
                无需下载App，浏览器直接访问即可，支持添加到主屏幕快捷方式
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}